import { render, staticRenderFns } from "./TransactionHistoryTable.vue?vue&type=template&id=7dffde12&scoped=true&"
import script from "./TransactionHistoryTable.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHistoryTable.vue?vue&type=style&index=0&id=7dffde12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dffde12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
